module.exports = __webpack_public_path__ + "static/media/2020_100k.665cdb97.gpx";